import { z } from 'zod'
import { parseWithZod } from '../utils'
import { auth } from './auth'
import { http } from './http'
import { DealTemplatesResponseSchema, DealTemplateResponseSchema } from '../schemas'

const UpdateDealTemplateResponseSchema = z.object({
  deal_usership: z.object({
    id: z.number(),
    is_trashed: z.boolean(),
  }),
})

export const dealTemplates = {
  getAll: async () => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.get(`${regionHost}/api/deal_templates`)
    return parseWithZod(DealTemplatesResponseSchema, result).deal_templates
  },
  getById: async (id: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.get(`${regionHost}/api/deal_templates/${id}`)
    return parseWithZod(DealTemplateResponseSchema, result).deal_template
  },

  getAdminTemplates: async () => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.get(`${regionHost}/api/deal_templates/org_admin_list`)
    return parseWithZod(DealTemplatesResponseSchema, result).deal_templates
  },

  updateArchived: async ({
    template_id,
    is_being_archived,
    deal_id,
    regionHost,
  }: {
    template_id: number
    is_being_archived: boolean
    deal_id: number
    regionHost?: string
  }) => {
    const host = regionHost ? `${location.protocol}//${regionHost}` : auth.getUserRegionHost()
    const endpoint = `${host}/api/deal_templates/${template_id}/${is_being_archived ? 'archive' : 'unarchive'}`
    const result = await http.post(endpoint, undefined, deal_id)
    return parseWithZod(UpdateDealTemplateResponseSchema, result)
  },

  editInfo: async (payload: { id: number; title: string; preamble?: string | null }) => {
    const { id, ...body } = payload
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(
      `${regionHost}/api/deal_templates/${id}/edit_template_deal_info`,
      body,
    )
    return parseWithZod(DealTemplateResponseSchema, result).deal_template
  },

  enableOrgAccess: async (dealTemplateId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(
      `${regionHost}/api/deal_templates/${dealTemplateId}/enable_org_access`,
    )
    return parseWithZod(DealTemplateResponseSchema, result).deal_template
  },

  // Disabling is asynchronous server-side: the response is empty and the updated
  // deal template arrives later through live sync
  disableOrgAccess: async (dealTemplateId: number) => {
    const regionHost = auth.getUserRegionHost()
    await http.post(`${regionHost}/api/deal_templates/${dealTemplateId}/disable_org_access`)
  },
}
